export default __webpack_public_path__ + "static/media/NotoSans-Bold.15dfc873.woff";